import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { FiEdit2 } from 'react-icons/fi';

import { getAllNewsAction } from '../../actions/newsActions';
import { getCongressAction } from '../../actions/userActions';
import ActuCard from '../../components/ActuCard/ActuCard';
import SortButton from '../../lib/SortButton';
import styles from '../../styles/consult.module.scss';
import actuStyles from './Actus.module.scss';

const initSortState = {
  title: true,
  author: true,
  date: true,
  status: true,
};

export default function ActusGestion() {
  const dispatch = useDispatch();
  const { newsAll, congress } = useSelector((state) => state.user);
  const [sortByReverse, setSortByReverse] = useState(initSortState);
  const [filteredList, setFilteredList] = useState([]);

  useEffect(() => {
    getAllNewsAction(dispatch);
    getCongressAction(dispatch);
  }, [dispatch]);

  useEffect(() => {
    setFilteredList([...(newsAll || [])]);
  }, [newsAll]);

  function sortList(type, isReverse) {
    const list = [...filteredList];
    switch (type) {
      case 'title':
        list.sort((a, b) => String(a.title || '').localeCompare(String(b.title || ''), 'fr'));
        break;
      case 'author':
        list.sort((a, b) => {
          const an = `${a.author?.profile?.firstName || ''} ${a.author?.profile?.lastName || ''}`.trim();
          const bn = `${b.author?.profile?.firstName || ''} ${b.author?.profile?.lastName || ''}`.trim();
          return an.localeCompare(bn, 'fr');
        });
        break;
      case 'date':
        list.sort((a, b) => {
          const aDate = a?.date ? new Date(a.date) : new Date(0);
          const bDate = b?.date ? new Date(b.date) : new Date(0);
          if (aDate < bDate) return -1;
          if (aDate > bDate) return 1;
          return 0;
        });
        break;
      case 'status':
        list.sort((a, b) => String(a.status || '').localeCompare(String(b.status || ''), 'fr'));
        break;
      default:
        break;
    }
    setFilteredList(isReverse ? list.reverse() : list);
    setSortByReverse({ ...initSortState, [type]: isReverse });
  }

  const colCount = 4;

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h2>Actualités</h2>
        <div className={styles.headerActions}>
          <Link to="/majee/actus/create" className={styles.btnPrimary}>
            Nouvelle actu
          </Link>
        </div>
      </header>

      {congress?.length > 0 && (
        <>
          <h3 className={actuStyles.congress} style={{ padding: '0 20px' }}>Congrès à venir</h3>
          <div className={actuStyles.cards} style={{ padding: '0 20px 20px' }}>
            {congress.map((c) => <ActuCard key={c._id} card={c} type="congres" />)}
          </div>
        </>
      )}

      <div className={styles.sort} style={{ '--cols': colCount }}>
        <div className={`${styles.row} ${styles.labels}`}>
          <SortButton
            name="Titre"
            handleClick={() => sortList('title', !sortByReverse.title)}
            state={sortByReverse.title}
            className={styles.col}
          />
          <SortButton
            name="Auteur"
            handleClick={() => sortList('author', !sortByReverse.author)}
            state={sortByReverse.author}
            className={`${styles.col} ${styles.desktop}`}
          />
          <SortButton
            name="Date"
            handleClick={() => sortList('date', !sortByReverse.date)}
            state={sortByReverse.date}
            className={`${styles.col} ${styles.desktop}`}
          />
          <SortButton
            name="Statut"
            handleClick={() => sortList('status', !sortByReverse.status)}
            state={sortByReverse.status}
            className={styles.col}
          />
          <div className={`${styles.edit} ${styles.desktop}`} />
        </div>
      </div>

      <div className={styles.list} style={{ '--cols': colCount }}>
        {filteredList.map((n) => (
          <Link
            key={n._id}
            to={`/majee/actus/${n._id}`}
            className={styles.row}
          >
            <div className={styles.col}>
              <p className={styles.name}>{n.title}</p>
            </div>
            <div className={`${styles.col} ${styles.desktop}`}>
              <p>
                {n.author?.profile
                  ? `${n.author.profile.firstName || ''} ${n.author.profile.lastName || ''}`
                  : '—'}
              </p>
            </div>
            <div className={`${styles.col} ${styles.desktop}`}>
              <p>{n.date ? format(new Date(n.date), 'dd.MM.yy') : '—'}</p>
            </div>
            <div className={styles.col}>
              <span
                className={`${styles.status} ${
                  n.status === 'published' ? styles.published : styles.draft
                }`}
              >
                {n.status === 'published' ? 'Publié' : 'Brouillon'}
              </span>
            </div>
            <div className={`${styles.edit} ${styles.desktop}`}>
              <span className={styles.editIcon}><FiEdit2 /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
